import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";


const resourceApi = createApi({
    reducerPath: 'resourceApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getAllResourcesList: builder.mutation({
            query: (details) => ({
                url: '/Resource/GetAllResourcesList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteResourceDetailById: builder.mutation({
            query: (id) => ({
                url: `/Resource/DeleteResourceDetailById?id=${parseInt(id)}`,
                method: 'POST',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getResourceDetailById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`Resource/GetResourceDetailById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        uploadPdfForResources: builder.mutation({
            query: (formData) => ({
                url: '/Resource/UploadPdfForResources',
                method: 'POST',
                body: formData, // FormData only
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addCorporateResources: builder.mutation({
            query: (details) => ({
                url: encryptQueryString('/Resource/AddCorporateResources'),
                method: 'POST',
                body: transformRequest(details), 
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
          downloadAllTypesDocForResource: builder.mutation({
            query: (formData) => ({
                url: '/Resource/DownloadAllTypesDocForResource',
                method: 'POST',
                body: transformRequest(formData),
                responseHandler: (response) => response.blob(),
            }),
            // transformResponse: transformSucessResponse,
            // transformErrorResponse: transformErrorResponse,
        }),
        getMembershipRetentionReport: builder.mutation({
            query: (details) => ({
                url: encryptQueryString('/Resource/GetMembershipRetentionReport'),
                method: 'POST',
                body: transformRequest(details), 
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useGetAllResourcesListMutation,
    useDeleteResourceDetailByIdMutation,
    useLazyGetResourceDetailByIdQuery,
    useUploadPdfForResourcesMutation,
    useAddCorporateResourcesMutation,
    useDownloadAllTypesDocForResourceMutation,
    useGetMembershipRetentionReportMutation
} = resourceApi;

export default resourceApi;